// Luật nhiệm vụ phía FE (THUẦN) — trùng backend admin-xu-mission-rules để báo lỗi sớm.
import { goldenHoursError } from "./xu-golden-hours-validate";

/** Lỗi của 1 nhiệm vụ đang sửa. @returns {string|null} */
export function missionError(m, meta) {
    if (!String(m.title || "").trim()) return "Hãy nhập tên hiển thị cho nhiệm vụ.";
    if (m.type === "view_screen") {
        if (!m.screen) return "Hãy chọn màn hình cần xem.";
        const [lo, hi] = meta.secondsRange;
        const n = Number(m.seconds);
        if (!Number.isInteger(n) || n < lo || n > hi) return `Số giây phải từ ${lo} đến ${hi}.`;
    }
    if (m.type === "buy_now") return goldenHoursError(m.goldenHours || []);
    if (m.type === "order_app" && !(Number(m.maxOrderAgeHours) >= 1)) return "Số giờ tính đơn phải từ 1 trở lên.";
    return null;
}

/** Tên màn đang có NV bật khác (trừ chính key đang sửa) — để chặn bật 2 NV cùng màn. */
export function screenConflict(missions, key, m) {
    if (m.type !== "view_screen" || !m.enabled) return null;
    const other = Object.entries(missions).find(([k, x]) => k !== key && x.enabled && x.type === "view_screen" && x.screen === m.screen);
    return other ? other[1].title : null;
}

/**
 * Key NV mới: v_<màn>_<base36>, ≤24 ký tự (backend: DeviceDailyClaims.kind VARCHAR(32) = "mission:" + key).
 * Cắt phần base36 (không cắt tiền tố) để key vẫn khác nhau giữa các lần tạo.
 */
export const newMissionKey = (screen) => {
    const prefix = `v_${screen}_`;
    return prefix + Date.now().toString(36).slice(-(24 - prefix.length));
};

/**
 * "Khôi phục mặc định" nhóm Nhiệm vụ: 3 key gốc về mặc định; NV tự tạo được GIỮ nhưng TẮT
 * (xoá sẽ bị backend từ chối 400 vì không được xoá NV đã có).
 */
export function resetMissionsToDefaults(current, defaults) {
    const out = { ...defaults };
    Object.entries(current || {}).forEach(([key, m]) => {
        if (!(key in defaults)) out[key] = { ...m, enabled: false };
    });
    return out;
}
